// @flow

import { type Node } from 'react';
import { useAutomaticRedirect } from './use-automatic-redirect';

export function AutoRedirectComponent(): Node {
  useAutomaticRedirect();
  return null;
}
